var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-nav'),_vm._v(" "),_c('div',{staticClass:"empty"},[_c('img',{staticClass:"img",attrs:{"src":require("@/asset/index/ic_empty.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"txt"},[_vm._v("您的网页走丢了！")]),_vm._v(" "),_c('div',{staticClass:"button",on:{"click":_vm.refresh}},[_vm._v("点击刷新")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }